import { dayMonthAndShortYearNoDash } from 'scripts/utilities/formatters';
import BrickPriceStat from 'src/components/propertyCards/common/stats/BrickPriceStat';
import EstNetRentalYieldStat from 'src/components/propertyCards/common/stats/EstNetRentalYieldStat';
import HistoricalSuburbGrowthStat from 'src/components/propertyCards/common/stats/HistoricalSuburbGrowthStat';
import PreOrderFlag from 'src/components/propertyCards/common/flags/PreOrderFlag';
import PrimaryButton from 'src/design/components/button/PrimaryButton';
import PropertyCardBodyFiveStatLayout from 'src/components/propertyCards/common/propertyCardBodyFiveStatLayout/PropertyCardBodyFiveStatLayout';
import PropertyCardButtonContainer from 'src/components/propertyCards/common/propertyCardButtonContainer/PropertyCardButtonContainer';
import PropertyCardContainer from 'src/components/propertyCards/common/propertyCardContainer/PropertyCardContainer';
import PropertyCardFeature from 'src/components/propertyCards/common/propertyCardHero/PropertyCardHero';
import PropertyCardHeader from 'src/components/propertyCards/common/propertyCardHeader/PropertyCardHeader';
import PropertyCardStat from 'src/components/propertyCards/common/propertyCardStat/PropertyCardStat';
import ViewsOrSelldown from 'src/components/propertyCards/propertyCardPreOrder/viewsOrSelldown/ViewsOrSelldown';
import { propertyUrl } from 'src/utils/pageUrls';

const PropertyCardPreOrder = ({ property, historicalGrowthMetrics }) => (
  <PropertyCardContainer link={propertyUrl(property.propertyCode)}>
    <PropertyCardHeader
      property={property}
      flag={<PreOrderFlag />}
      style={PropertyCardHeader.styles.PRE_LAUNCH}
    />
    <PropertyCardFeature property={property} />
    <PropertyCardBodyFiveStatLayout
      primary={<ViewsOrSelldown property={property} />}
      secondaries={[
        <EstNetRentalYieldStat property={property} />,
        <HistoricalSuburbGrowthStat
          historicalGrowthMetrics={historicalGrowthMetrics}
          propertyType={property.propertyType}
        />,
        <BrickPriceStat property={property} />,
        <PropertyCardStat
          label={
            <span>
              Settlement
              <br />
              Date
            </span>
          }
          value={property.platformSettlementDate::dayMonthAndShortYearNoDash()}
          valueProps={{ 'data-test-reference': 'settlement-date' }}
        />,
      ]}
    />
    <PropertyCardButtonContainer>
      <PrimaryButton
        className="property-card__button"
        color={PrimaryButton.colors.ACCENT}
        arrow
        testRef="button"
      >
        PRE-ORDER NOW
      </PrimaryButton>
    </PropertyCardButtonContainer>
  </PropertyCardContainer>
);

export default PropertyCardPreOrder;
